import { Factory, QuickFactory } from '@infodata-group/inf-commons';
import { Company } from '../model/company';
import { BoCompanyInterface } from '../interface/back-office/bo-company.interface';
import { Address } from '../engine/address';

export class CompanyFactory extends QuickFactory implements Factory<Company> {
  build(o: BoCompanyInterface): Company {
    const company = new Company(o.entId, o.entLabel);
    this.generateProperty(company, o);
    company.colors = o.colors;
    company.address = new Address({
      number: o.entAddressNumber,
      city: o.entAddressCity,
      path: o.entAddressPath,
      zipCode: o.entAddressPostalCode,
      country: o.entAddressCountry,
    });
    return company;
  }

  getApi(): string {
    return 'administration/entreprise/';
  }
}
